import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Map, MapPin, Star } from "lucide-react";
import { DESTINATIONS } from "../../mock";
import { Reveal, SectionHeading } from "../common";

export default function Destinations() {
  const bali = DESTINATIONS[0];

  return (
    <section id="projects" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-8">
        <SectionHeading
          eyebrow="Where you can go"
          title="200+ projects across 20+ countries"
          text="Our flagship destination is open for bookings right now and every other country we work in is listed in the sitemap."
        />

        <Reveal className="mt-14">
          <div className="grid overflow-hidden rounded-[32px] bg-ivi-sand shadow-[0_28px_64px_-40px_rgba(24,40,32,0.55)] lg:grid-cols-2">
            <Link
              to={bali.slug}
              className="group relative block min-h-[340px] overflow-hidden lg:min-h-[440px]"
            >
              <img
                src={bali.img}
                alt={bali.name}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1100ms] ease-out group-hover:scale-[1.08]"
              />
              <span className="absolute inset-0 bg-gradient-to-t from-ivi-slate/70 via-transparent to-transparent" />
              <span className="absolute left-6 top-6 inline-flex items-center gap-1.5 rounded-full bg-white/92 px-3.5 py-1.5 font-heading text-[12px] font-bold text-ivi-greenDark">
                <Star className="h-3.5 w-3.5 fill-ivi-green text-ivi-green" />
                Most booked destination
              </span>
              <span className="absolute bottom-6 right-6 grid h-12 w-12 place-items-center rounded-full bg-ivi-green text-white transition-transform duration-300 group-hover:rotate-45">
                <ArrowUpRight className="h-5 w-5" />
              </span>
            </Link>

            <div className="flex flex-col justify-center p-9 lg:p-14">
              <p className="flex items-center gap-2 font-heading text-[13px] font-bold uppercase tracking-[0.16em] text-ivi-greenDark">
                <MapPin className="h-4 w-4" /> Indonesia · Ubud · Lovina · Lombok · Nusa Penida
              </p>
              <h3 className="mt-4 font-heading text-[34px] font-extrabold leading-tight tracking-[-0.02em] text-ivi-slate sm:text-[42px]">
                {bali.name}
              </h3>
              <p className="mt-5 text-[17px] leading-relaxed text-ivi-slateSoft">{bali.blurb}</p>

              <div className="mt-8 flex flex-wrap gap-8">
                <span>
                  <span className="block font-heading text-[28px] font-extrabold leading-none text-ivi-greenDark">
                    {bali.projects}
                  </span>
                  <span className="mt-1.5 block text-[12px] font-semibold uppercase tracking-[0.14em] text-ivi-slateSoft">
                    Projects
                  </span>
                </span>
                <span>
                  <span className="block font-heading text-[28px] font-extrabold leading-none text-ivi-greenDark">
                    ${bali.from}
                  </span>
                  <span className="mt-1.5 block text-[12px] font-semibold uppercase tracking-[0.14em] text-ivi-slateSoft">
                    From, USD
                  </span>
                </span>
                <span>
                  <span className="block font-heading text-[28px] font-extrabold leading-none text-ivi-greenDark">
                    24/7
                  </span>
                  <span className="mt-1.5 block text-[12px] font-semibold uppercase tracking-[0.14em] text-ivi-slateSoft">
                    In-country support
                  </span>
                </span>
              </div>

              <div className="mt-10 flex flex-wrap gap-4">
                <Link
                  to={bali.slug}
                  className="group inline-flex items-center gap-2 rounded-full bg-ivi-green px-7 py-3.5 font-heading text-[15px] font-bold text-white transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-ivi-greenDark"
                >
                  Explore Bali
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:rotate-45" />
                </Link>
                <Link
                  to="/sitemap"
                  className="inline-flex items-center gap-2 rounded-full border border-ivi-mintDeep bg-white px-7 py-3.5 font-heading text-[15px] font-bold text-ivi-slate transition-[background-color,border-color,transform] duration-200 hover:-translate-y-0.5 hover:border-ivi-green hover:bg-ivi-mint"
                >
                  <Map className="h-4 w-4" /> All destinations
                </Link>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
